(() => {
  const selector = "template[data-cf-collection-image]";
  const boundGrids = new Map();
  function bind(grid) {
    if (grid.dataset.cfImagesBound) return;
    grid.dataset.cfImagesBound = "true";
    const hydrate = (template) => {
      if (!template || !grid.contains(template)) return;
      const fallback = template.nextElementSibling;
      const fragment = template.content.cloneNode(true);
      template.replaceWith(fragment);
      if (fallback?.matches("noscript[data-cf-card-fallback]")) fallback.remove();
    };
    const io = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        hydrate(entry.target.querySelector(selector));
        io.unobserve(entry.target);
      });
    }, { rootMargin: "450px 0px" }) : null;
    function scan() {
      io?.disconnect();
      grid.querySelectorAll(selector).forEach((template) => {
        if (io) io.observe(template.parentElement);
        else hydrate(template);
      });
    }
    scan();
    // Dawn replaces this stable container’s contents after filters and sorting.
    const changes = new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) scan();
    });
    changes.observe(grid, { childList: true, subtree: true });
    const onFocus = (event) => {
      const card = event.target.closest(".card-wrapper");
      card?.querySelectorAll(selector).forEach(hydrate);
    };
    grid.addEventListener("focusin", onFocus);
    boundGrids.set(grid, () => {
      io?.disconnect();
      changes.disconnect();
      grid.removeEventListener("focusin", onFocus);
      delete grid.dataset.cfImagesBound;
    });
  }
  const init = (scope) => {
    // Collection tabs replace the section itself; release observers on old grids.
    boundGrids.forEach((dispose, grid) => {
      if (grid.isConnected) return;
      dispose();
      boundGrids.delete(grid);
    });
    if (scope.matches?.("[data-cf-card-image-grid]")) bind(scope);
    scope.querySelectorAll("[data-cf-card-image-grid]").forEach(bind);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
  else init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("fmcp:collection-switched", () => init(document));
})();
